module.exports = __webpack_public_path__ + "img/9e70441e430648beba5442486b2f107b.cc6b4e45.png";